import React from "react";
import Header from "../include/Header"
import Contents from "../include/Contents"
import ContactInfo from "../include/ContactInfo"
import Footer from "../include/Footer"
import WrapTitle from "../include/WrapTitle"
import Loader from "../include/Loader"

// import axios from 'axios';


class Script extends React.Component {

    //데이터 저장소 // 데이터를 감지해서 바꿔줌!
    state = {
        isLoading : true,
    }


    //생명주기함수 
    componentDidMount(){
        setTimeout(()=>{
            this.setState({isLoading : false});
        },2000)
    }

    render(){
        const {isLoading} = this.state;

        return (
            <div>
                { isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        <Header/>
                        <Contents>
                            <section id="scriptCont">
                                <div className="container">
                                    <WrapTitle text={["Script","Reference"]}/>
                                    <div className="script__cont">
                                    </div>
                                </div>
                            </section>
                            {/* //scriptCont */}
                            <ContactInfo />
                            {/* //contactInfo */}
                        </Contents>
                        <Footer/>
                    </div>
                )}
            </div> 
            
        )
    }
}

export default Script;
